import { createSelector } from '@reduxjs/toolkit'
import { mapItemPolicyRowsToAggregateOfferCredit } from 'businessTraveller/utils/mapItemPolicyRowsToOfferCredit'

export const selectItemPolicyOfferCredit = createSelector(
  (state: App.State, cacheKey: string) => state.businessTraveller.itemPolicyEvaluations?.[cacheKey],
  (calculation): App.BusinessTraveller.OfferCredit | undefined => {
    if (!calculation || calculation.status !== 'success') {
      return undefined
    }
    return mapItemPolicyRowsToAggregateOfferCredit(calculation.rowsByEmployee)
  },
)
